// extracted by mini-css-extract-plugin
export var displayNone = "_u6-6";
export var imgContainer = "_u6-2";
export var overflowHidden = "_u6-3";
export var productInfoCardButtonContainer = "_u6-5";
export var productTitleText = "_u6-4";
export var rightArrow = "_u6-1";
export var rightArrowContainer = "_u6-0";